<action-box class="detail-item tab-detail {{extraStyles}}" [isIconLeftVault]="isVault" iconLeft="{{icon}}" textLeft="{{tab.title}}">
  <gridview *ngIf="contentVisible">
    <gridview-row *ngFor="let row of rows"
                  classes="row-data">
      <columntemplate *ngFor="let list of row.cells" classes="min-width col-12 col-sm-6">
        <summary-param-detail *ngIf="list.backgroundImage != 'variablepanel'; else variableDetail" [list]="list"></summary-param-detail>
        <ng-template #variableDetail>
          <list [list]="list" (mouseenter)="openVariablePopup(list)" (click)="openVariablePopup(list)"></list>
        </ng-template>
      </columntemplate>
    </gridview-row>
  </gridview>
  <div card-type="control" *ngIf="isPrintView">
    <print-checkbox (onValueChange)="onPrintValueChange($event)"></print-checkbox>
  </div>
</action-box>